$(document).ready(function () {
    let $zoomVideo = $('.zoom-video:not(.zoom-video-self-hosted) a');
    $zoomVideo.on('click', function(e) {
        e.stopPropagation();
        console.info('clicked');
    });
    $zoomVideo.magnificPopup({
        type: 'iframe',
        disableOn: 700,
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,
        iframe: {
            patterns: {
                // this vimeo section is here to allow full screen on vimeo embedded videos
                vimeo: {
                    index: 'vimeo.com/',
                    id: function(url) {
                        return url.split('/').pop();
                    },
                    src: '//player.vimeo.com/video/%id%?autoplay=1&title=0&byline=0&portrait=0&fullscreen=1'
                }
            }
        }
    });
    let $selfZoomVideo = $('.zoom-video-self-hosted a');
    $selfZoomVideo.magnificPopup({
        type: 'inline',
        disableOn: 700,
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: true,
        fixedContentPos: false
    })
});
